import jwtDecode from 'jwt-decode';

const LS_TOKEN = 'id_token';
const LS_TOKEN_EXPIRES = 'id_token_expires';

export function updateToken(token: string): void {
    localStorage[LS_TOKEN] = token;
    const tokenDecoded = jwtDecode(token);
    // eslint-disable-next-line
    // @ts-ignore 
    localStorage[LS_TOKEN_EXPIRES] = tokenDecoded.exp;
}

export function getToken(): string {
    return localStorage[LS_TOKEN] || '';
}

export function getTokenExpires(): number {
    return localStorage[LS_TOKEN_EXPIRES];
}

export function authenticated(): boolean {
    if (!localStorage[LS_TOKEN_EXPIRES]) {
        return false;
    }
    const now = new Date();
    const nowEpoch = Math.round(now.getTime() / 1000);
    return nowEpoch < localStorage[LS_TOKEN_EXPIRES];
}

export function logout(): void {
    localStorage[LS_TOKEN_EXPIRES] = 0;
    localStorage[LS_TOKEN] = '';
}
